module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-home page-submenu"
  }, [_c('div', {
    staticClass: "e2e-container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "user-manual"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('div', {
    staticClass: "manual-container"
  }, [_c('div', {
    staticClass: "manual-desc"
  }, [_vm._v("如您有任何关于会议计划平台以及会议活动相关的问题或建议，可以下载手册文档以获取帮助,或欢迎点击以下链接访问 gSite。")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('FileBox', {
    staticStyle: {
      "margin-top": "32px",
      "margin-bottom": "100px"
    },
    attrs: {
      "fileList": _vm.fileList,
      "disabled": true,
      "disabledDelete": true,
      "autoUpload": false,
      "lineNum": 2,
      "accept": "pdf,image",
      "label": _vm.$t('home.manual'),
      "download": true
    },
    on: {
      "update:fileList": function($event) {
        _vm.fileList = $event
      },
      "update:file-list": function($event) {
        _vm.fileList = $event
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-desc"
  }, [_c('a', {
    attrs: {
      "href": "https://sites.google.com/roche.com/eme-sharing-g-site/home",
      "target": "_blank"
    }
  }, [_vm._v("https://sites.google.com/roche.com/eme-sharing-g-site/home")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0bd5cfca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bd5cfca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/user/manual/index.vue
// module id = 1550
// module chunks = 7